module.exports = async (doc) => Object.entries(await doc);
